import _ from "lodash";

export function getRefId(ref) {
  if (ref == null || ref === "") return null;
  if (typeof ref === "string" || typeof ref === "number") return String(ref);
  if (typeof ref === "object") {
    const id = ref._id;
    if (id == null || id === "") return null;
    return typeof id.toString === "function" ? id.toString() : String(id);
  }
  return null;
}

export function resolveClientRecordId(client, form, fieldName) {
  if (!client) return null;
  const fromClient = getRefId(client);
  if (fromClient) return fromClient;

  if (form && fieldName) {
    const clientRefPath = fieldName.replace(/SnapShot$/i, "");
    if (clientRefPath !== fieldName) {
      return getRefId(_.get(form.values, clientRefPath));
    }
  }

  return null;
}

const pickLabel = (...candidates) =>
  candidates.find((value) => value != null && String(value).trim() !== "") ??
  null;

const asObject = (value) =>
  value && typeof value === "object" ? value : null;

export function getOrderServiceRelatedPages(service) {
  const nestedOrder = asObject(service?.orderId);
  const orderId = getRefId(nestedOrder) || getRefId(service?.orderId);
  const snapshot = nestedOrder?.clientSnapShot;
  const product = asObject(nestedOrder?.product);
  const provider =
    asObject(nestedOrder?.provider) ?? asObject(product?.provider);
  const clientId = getRefId(nestedOrder?.client) || getRefId(snapshot);

  return {
    order: orderId
      ? { id: orderId, label: pickLabel(nestedOrder?.code, service?.orderCode, orderId) }
      : null,
    client: clientId
      ? {
          id: clientId,
          label: pickLabel(snapshot?.code, snapshot?.name, clientId),
        }
      : null,
    provider: getRefId(provider)
      ? {
          id: getRefId(provider),
          label: pickLabel(provider.name, provider.code, getRefId(provider)),
        }
      : null,
    product: getRefId(product)
      ? {
          id: getRefId(product),
          label: pickLabel(product.name, product.code, getRefId(product)),
        }
      : null,
  };
}
